import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import strFunc from '@/lib/lyg/string';

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;
  const [category_arr, set_category_arr] = useState<any>([]);
  const [sort1_arr, set_sort1_arr] = useState<any>([]);
  const [sort2_arr, set_sort2_arr] = useState<any>([]);
  const [sort3_arr, set_sort3_arr] = useState<any>([]);
  let select_subject_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });

  useEffect(() => {
    if(listOpt.s_subject && listOpt.s_subject!=""){
      get_textbook_sort_by_ajax({ s_type: "category", s_par_id: "subject", s_par_seq: listOpt.s_subject });
    }
  }, []);

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    let change_list_opt: any = {
      ...myProps.listOpt,
    };
    change_list_opt[name] = value;

    if (name == "s_subject") {
      change_list_opt["s_category_seq"] = "";
      change_list_opt["s_sort1_seq"] = "";
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort1_arr([]);
      set_sort2_arr([]);
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_category_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "category", s_par_id: "subject", s_par_seq: value });
      }
    } else if (name == "s_category_seq") {
      change_list_opt["s_sort1_seq"] = "";
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort2_arr([]);
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_sort1_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort1", s_par_seq: value });
      }
    } else if (name == "s_sort1_seq") {
      change_list_opt["s_sort2_seq"] = "";
      change_list_opt["s_sort3_seq"] = "";
      set_sort3_arr([]);
      if (strFunc.is_empty(value)) {
        set_sort2_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort2", s_par_seq: value });
      }
    } else if (name == "s_sort2_seq") {
      change_list_opt["s_sort3_seq"] = "";
      if (strFunc.is_empty(value)) {
        set_sort3_arr([]);
      } else {
        get_textbook_sort_by_ajax({ s_type: "sort3", s_par_seq: value });
      }
    }

    myProps.list({
      ...change_list_opt,
      now_page: 1
    });
  };

  const get_textbook_sort_by_ajax = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "mtextbook_sort",
      s_par_seq: "",
      ...inData
    };

    let formJsonData = {
      s_type: opt_obj.s_type,
      s_par_id: opt_obj.s_par_id,
      s_par_seq: opt_obj.s_par_seq,
      order_id: "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/sort/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort3") {
            set_sort3_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "category") {
            set_category_arr(response.data["data"]["info_arr"]);
          }
        }
      });
  };

  return (
    <div className="search-box">

      <select name="s_subject" value={myProps.listOpt.s_subject} className="search-input"
        onChange={on_change_search_input} style={{ width: '100px' }}>
        <option value="">과목</option>
        {select_subject_arr.map((item: any, index: number) => (
          <option key={index} value={item.value}>{item.text}</option>
        ))}
      </select>
      <select name="s_category_seq" value={myProps.listOpt.s_category_seq} className="search-input"
        onChange={on_change_search_input} style={{ width: '100px' }}>
        <option value="">카테고리</option>
        {category_arr.map((item: any, index: number) => (
          <option key={index} value={item.a_seq}>{item.a_title}</option>
        ))}
      </select>
      <select name="s_sort1_seq" value={myProps.listOpt.s_sort1_seq} className="search-input ml-1"
        onChange={on_change_search_input} style={{ width: '100px' }}>
        <option value="">대분류</option>
        {sort1_arr.map((item: any, index: number) => (
          <option key={index} value={item.a_seq}>{item.a_title}</option>
        ))}
      </select>
      <select name="s_sort2_seq" value={myProps.listOpt.s_sort2_seq} className="search-input ml-1"
        onChange={on_change_search_input} style={{ width: '100px' }}>
        <option value="">중분류</option>
        {sort2_arr.map((item: any, index: number) => (
          <option key={index} value={item.a_seq}>{item.a_title}</option>
        ))}
      </select>
      <select name="s_sort3_seq" value={myProps.listOpt.s_sort3_seq} className="search-input ml-1"
        onChange={on_change_search_input} style={{ width: '100px' }}>
        <option value="">소분류</option>
        {sort3_arr.map((item: any, index: number) => (
          <option key={index} value={item.a_seq}>{item.a_title}</option>
        ))}
      </select>
      <input type='text' name="s_title_like" value={myProps.listOpt.s_title_like} className='search-input ml-1'
        onChange={on_change_search_input} style={{ width: '100px' }}
        placeholder='제목 검색' autoComplete='off' />
      <button className='btn btn-dark' onClick={() => { myProps.list({}); }}>검색</button>
    </div>
  );
};
export default SearchArea;